import { useCallback, useContext } from 'react';
import { isTablePlugin, isLegacyTablePlugin, usePlugins } from '@deephaven/plugin';
import Log from '@deephaven/log';
import { TablePluginLoaderContext } from "./TablePluginLoaderContext.js";
var log = Log.module('@deephaven/app-utils/useTablePlugin');

/**
 * Creates a table plugin loader function.
 * @returns A function to load a Table plugin element by name
 */
export function useLoadTablePlugin() {
  var plugins = usePlugins();
  var loaderFromContext = useContext(TablePluginLoaderContext);
  var plugin = useCallback(name => {
    // First check if we have any plugin modules loaded that match the TablePlugin.
    var pluginModule = plugins.get(name);
    if (pluginModule != null) {
      if (isTablePlugin(pluginModule)) {
        return pluginModule.component;
      }
      if (isLegacyTablePlugin(pluginModule)) {
        return pluginModule.TablePlugin;
      }
    }

    // Fall back to the loader function provided via context, if any.
    if (loaderFromContext != null) {
      return loaderFromContext(name);
    }
    var errorMessage = "Unable to find table plugin ".concat(name, ".");
    log.error(errorMessage);
    throw new Error(errorMessage);
  }, [plugins, loaderFromContext]);
  return plugin;
}
export default useLoadTablePlugin;
//# sourceMappingURL=useLoadTablePlugin.js.map